'use client';

import { Container } from 'react-bootstrap';
import type { PortableTextBlock } from 'next-sanity';

import FontAwesomeIcon from '@/componentv2/fontAwesomeIcon/fontAwesomeIcon';
import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import type { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';
import { getSectionBackgroundStyle } from '../../utils';
import './ProblemSection.scss';

type LandingPageData = Extract<
  NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>,
  { _type: 'landingPage' }
>;

interface ProblemSectionProps {
  data: NonNullable<LandingPageData['problemSection']>;
}

export default function ProblemSection({ data }: ProblemSectionProps) {
  const { sectionLabel, sectionHeadline, problemCards, background } = data;

  return (
    <section
      className="rlp-problem-section"
      style={getSectionBackgroundStyle(background)}
    >
      <Container>
        {sectionLabel && (
          <span className="rlp-section-label">{sectionLabel}</span>
        )}
        {sectionHeadline && (
          <div className="rlp-section-headline">
            <LandingPortableText
              value={sectionHeadline as PortableTextBlock[]}
            />
          </div>
        )}
        {problemCards && problemCards.length > 0 && (
          <div className="rlp-problem-cards">
            {problemCards.map((card) => (
              <div className="rlp-problem-card" key={card._key}>
                <div className="rlp-problem-card-header">
                  {card.icon?.name && (
                    <FontAwesomeIcon
                      name={card.icon.name}
                      style={card.icon.style}
                      family={card.icon.family}
                      fontSize="22px"
                    />
                  )}
                  {card.title && <h3>{card.title}</h3>}
                </div>
                {card.description && (
                  <LandingPortableText
                    value={card.description as PortableTextBlock[]}
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}
